import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.666992 11.3327H11.3337M6.00033 7.33268V0.666016M6.00033 7.33268L8.66699 4.66602M6.00033 7.33268L3.33366 4.66602", stroke: "#667085", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDownloadIcon);
export default ForwardRef;
